export const FeatureFlagKeys = {
    TT_QUIZ_FLOW_CONTROLLER: "tt_quiz_flow_controller",
    TT_QUIZ_FLOW_DESKTOP_CONTROLLER: "tt_quiz_flow_desktop_controller",
    GLUTEN_FREE_TT_CTA_TARGET: "gluten_free_tt_cta_target",
    TT_AI_QUIZ_FLOW_VARIATIONS: "tt_ai_quiz_flow_variations",
    STABLE_TT_AI_QUIZ_FLOW_VARIATIONS: "stable_tt_ai_quiz_flow_variations",
    GFE_TT_QUIZ_FLOWS_CHECKOUT_TYPE: "gfe_tt_quiz_flows_checkout_type",
    GFE_TT_CHECKOUT_TRIAL: "gfe_tt_checkout_trial",
    GFE_TT_AD_CHECKOUT_TRIAL: "gfe_tt_ad_checkout_trial",
    INDIRECT_ADS_QUIZ_PRICE: "indirect_ads_quiz_price",
    GFETT_BRANCH_STABILITY_VARIATION: "gfett-branch-stability-variation",
    GFETT_PRICING_TEST: "gfett_pricing_test",
    INDIRECT_ADS_COUPON_ID: "indirect_ads_coupon_id",
};

export const FeatureFlagValues = {
    [FeatureFlagKeys.TT_QUIZ_FLOW_CONTROLLER]: {
        A: "a-short-quiz",
        B: "b-long-quiz",
        C: "c-ai-variation-quiz",
    },
    [FeatureFlagKeys.TT_AI_QUIZ_FLOW_VARIATIONS]: {
        A: "flow_a",
        B: "flow_b",
        C: "flow_c",
        D: "flow_d",
        E: "flow2_e",
        EMAIL_AT_END: "flow2_emailAtEnd",
    },
    [FeatureFlagKeys.GFE_TT_QUIZ_FLOWS_CHECKOUT_TYPE]: {
        WEB: "web",
        APP: "app",
    },
    [FeatureFlagKeys.GFE_TT_CHECKOUT_TRIAL]: {
        TRUE: "true",
        FALSE: "false",
    },
    [FeatureFlagKeys.GFETT_BRANCH_STABILITY_VARIATION]: {
        STABLE: true,
        EXPERIMENTAL: false,
    },
    [FeatureFlagKeys.GFETT_PRICING_TEST]: {
        "49.99": "49.99",
        "59.99": "59.99",
        "69.99": "69.99",
        "79.99": "79.99",
        "99.99": "99.99",
    },
};
